<template>
</template>

<script lang="ts">
import {getCurrentInstance, onMounted, Ref, ref} from "vue";
import {useI18n} from "vue-i18n";
import SrvRequest from "@/composables/SrvRequest";
import {useCommonStore} from "@/stores/useCommonStore";
import {storeToRefs} from "pinia";
import {useUserTokenStore} from "@/stores/useUserTokenStore";
import useUserDataStore from "@/stores/useUserDataStore";
import {DashboardData} from "../types/signed/dashboard";
//import Chatbox from 'https://cdn.mu.chat/embeds/dist/chatbox/index.js?v=2';

export default {
  name: "liveSupportChat",
  setup(){
    const {t} = useI18n();
    const http = SrvRequest();
    const cmonStore = useCommonStore();
    const authStore = useUserTokenStore();
    const { userDashboardData } = storeToRefs(useUserDataStore().useDashboardStore()) as {userDashboardData:Ref<DashboardData>};
    const initGoftinoWidget = (()=>{
      !function(){var i="VZJprk",a=window,d=document;function g(){var g=d.createElement("script"),s="https://www.goftino.com/widget/"+i,l=localStorage.getItem("goftino_"+i);g.async=!0,g.src=l?s+"?o="+l:s;d.getElementsByTagName("head")[0].appendChild(g);}"complete"===d.readyState?g():a.attachEvent?a.attachEvent("onload",g):a.addEventListener("load",g,!1);}();
      window.addEventListener('goftino_ready', function () {
        Goftino.setWidget({
          iconUrl: '',
          cssUrl: '',
          soundUrl: '',
          marginRight: 0,
          marginLeft: 0,
          marginBottom: 0,
          hasIcon: false,
          hasSound: false,
          counter: '#div_idName'  //or '.div_className'
        });
        window.addEventListener('goftino_getMessage', function (d) {
          if(d.detail.type === 'text') {
            Goftino.open();
          }
        });
      });
    });
    const iniMuchatWidget = (async (contact)=>{
      if (window.__muChatLoaded) return;
      try {
        const { default: Chatbox } = await import('https://cdn.mu.chat/embeds/dist/chatbox/index.js?v=2');
        const configs = {
          agentId: 'cmb9utef900hbufpqtls27d1f',
        };
        if (contact !== null){
          configs.contact = contact;
        }
        const widget = await Chatbox.initBubble(configs);
        window.Muchat.on('muchat_ready', () => {
          //window.Muchat.open()
          hideMuchatBubble();
        });
        window.Muchat.on('muchat_sendMessage', ({ message }) => {
          window.Muchat.open();
        });
        window.__muChatLoaded = true;
      } catch (error) {
        console.error('Failed to load Mu.Chat widget:', error);
      }
    })
    const hideMuchatBubble = ()=>{
      document.querySelector('muchat-chatbox-bubble')?.style.setProperty('display', 'none', 'important');
    }
    onMounted(async ()=>{
      //const res = await http.get("/public/chat_app");
      initGoftinoWidget();
      // cmonStore.liveChatApp = "MUCHAT";
      // if (cmonStore.liveChatApp === "GOFTINO"){
      //
      // }else{
      //   let contact = null;
      //   if (authStore.isLogined()) {
      //     contact = {
      //       firstName:userDashboardData.value.user_name,
      //       lastName:'',
      //       phoneNumber:userDashboardData.value.user_tellphone,
      //       userId:userDashboardData.value.user_id
      //     }
      //   }
      //   iniMuchatWidget(contact);
      //   hideMuchatBubble();
      });
  }
}
</script>

<style>

</style>